export const homeContact = {
    title: "Ready to seek new opportunities?",
    subtitle: "Seek opportunities today",
    btnText: "Contact Us",
}
